module.exports = __webpack_public_path__ + "static/media/logo_l.5ab3807a.svg";